import React from 'react';
export function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="pt-48 pb-24 md:pt-64 md:pb-32 max-w-6xl mx-auto px-6" data-id="element-117">
      <div className="max-w-4xl" data-id="element-118">
        <h1 className="text-6xl md:text-8xl font-light tracking-tight text-black leading-[1.1] mb-12" data-id="element-119">
          Execution for the next inflection point.
        </h1>
        <p className="text-xl md:text-2xl text-gray-600 leading-relaxed max-w-2xl font-light mb-8" data-id="element-120">
          Short-term, embedded execution leadership for founders carrying too
          much and operating under time pressure.
        </p>
        <p className="text-sm md:text-base text-gray-400 uppercase tracking-widest mb-12" data-id="element-121">
          COO- and Chief of Staff–level execution, inverted for pre-PMF speed.
        </p>
        <button onClick={scrollToContact} className="text-sm font-bold uppercase tracking-widest border-b-2 border-black pb-1 hover:text-gray-600 hover:border-gray-600 transition-colors" data-id="element-122">
          Start a conversation
        </button>
      </div>
    </section>;
}